import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type DirtyState = Record<string, boolean>;

const initialState: DirtyState = {};

const navigationSlice = createSlice({
    name: "navigation",
    initialState,
    reducers: {
        setDirty: (state, action: PayloadAction<{ formId: string; isDirty: boolean }>) => {
            const { formId, isDirty } = action.payload;
            state[formId] = isDirty;
        },
        resetAll: () => initialState,
    },
});

export const navigationReducerActions = navigationSlice.actions;
export default navigationSlice.reducer;
